import { FormatType, getFormatter } from '@revelio/replots';

function formatTinyDecimal(value: number): string {
  const abs = Math.abs(value);
  const decimals = Math.min(10, Math.max(2, Math.ceil(-Math.log10(abs)) + 2));
  const fixed = value.toFixed(decimals);
  return fixed.replace(/\.?0+$/, '');
}

export function getPrettyFormatValue(
  format: FormatType
): (value: number) => string {
  const base = getFormatter(format);

  if (format !== FormatType.DECIMAL) {
    return base;
  }

  return (value: number) => {
    const abs = Math.abs(value);
    if (abs > 0 && abs < 0.01) return formatTinyDecimal(value);
    return base(value);
  };
}
